import axios from 'axios';

const SCROOGE_API = 'https://ngs.ru/ump-api/service-scrooge/graphql';
const query = `
fragment adunit on Adunit {
    id
    projectKey
    adserver
    placement
    layout
    placeholderEnabled
    placeholderConfig {
        height
        backgroundEnabled
        bordersEnabled
        advMarkEnabled
        advMarkInnerEnabled
    }
    refreshEnabled
    refreshConfig {
        refreshInterval
        viewportTime
    }
    adfoxConfig {
        p1
        p2
    }
    rtbConfig {
        id
    }
    gptConfig {
        adUnitPath
        sizes {
            sizes0x0
            sizes336x0
        }
    }
    scroogeConfig {
        fill
    }
    biddersConfig {
        codeType
        sizes
    },
    advInfoPosition
}

query getAdsConfig($filter: AdsConfigFilterInput!) {
    result: adsConfig(filter: $filter) {
        __typename
        ...on AdsConfig {
            adunits {
                ...adunit
            }
            bidders {
                id
                key
                adserver
                adserverBidderId
                params {
                    key
                    type
                }
            }
            adunitsBidders {
                id
                placement
                params {
                    key
                    value
                }
            }
        }
        ...on ProblemInterface {
            message
        }
    }
}
`;

export async function getAdsConfig (variables) {
    const data = { variables, query };
    const { data: response } = await axios.post(SCROOGE_API, data, {
        headers: { 'Content-Type': 'application/json', },
    });

    if (!response.data.result) {
        if (response.errors.length > 0) {
            throw new Error(response.errors[0].message);
        }

        throw new Error(`[CreativeManager]: конфиг проекта не найден ${JSON.stringify(response)}`);
    }

    const config = response.data.result;
    config.layout = 'STANDART';

    return config;
}



// WEBPACK FOOTER //
// ./src/services/getAdsConfig.js